module.exports = "//cdn.mxpnl.com/static/asset-cache/e2dc8b978cb51e08cd147ff174df742d/iron/common/assets/images/partner-logos/segment.svg";